import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetPatronSweepstakesById = ({
  patronId,
}: {
  patronId: number
}) => {
  const get = useTypedApiClient({
    path: '/admin/patron/{patronId}/sweepstakes',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/patron-sweepstakes', patronId],
    queryFn: async () => {
      const { data } = await get({
        patronId,
      })
      return data
    },
  })
}
